<template>
  <div>
    <div class="kqf-card mg10 search-box mt20">
      <el-form
        :inline="true"
        :model="search"
        size="mini"
        class="demo-form-inline"
      >
        <el-col :span="24">
          <el-form-item label="审核状态">
            <el-radio-group v-model="search.audit_status" @input="getList(1)">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">待审核</el-radio>
              <el-radio :label="2">审核通过</el-radio>
              <el-radio :label="3">审核不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="流水类型" class="ml20">
            <el-radio-group v-model="search.flow_type" @input="getList(1)">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">佣金收入</el-radio>
              <el-radio :label="2">提现支出</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="商户号状态" class="ml20">
            <el-radio-group v-model="search.pay_status" @input="getList(1)">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="2">已打款</el-radio>
              <el-radio :label="3">打款失败</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <div class="line-dashed mb10"></div>
        </el-col>

        <el-form-item label="关键字：">
          <el-input
            v-model="search.user_keyword"
            placeholder="请输入昵称或手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="下级关键字：">
          <el-input
            v-model="search.friend_keyword"
            placeholder="请输入昵称或手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="search.submit_time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="审核时间">
          <el-date-picker
            v-model="search.audit_time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="账单时间">
          <el-date-picker
            v-model="search.create_time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList(1)">查询</el-button>
          <el-button @click="refresh">重置</el-button>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            总申请金额：<span class="num">{{ datas.total_amount }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            已到账金额：<span class="num">{{
              datas.total_payment_amount
            }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            未到账金额：<span class="num">{{
              datas.total_unpayment_amount
            }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            总充值金额：<span class="num">{{ datas.total_friend_amount }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            总送出佣金：<span class="num">{{ datas.total_cost_amount }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="kqf-card mg10 pd10 mt20"
      v-loading="loading"
      style="min-width: 1100px"
    >
      <el-table
        border
        :data="datas.list"
        height="calc(100vh - 280px)"
        @sort-change="orderby"
      >
        <el-table-column label="ID" width="80" prop="id"></el-table-column>
        <el-table-column label="用户信息" width="350">
          <template slot-scope="scope">
            <div class="flex" v-if="scope.row.hasUsers">
              <div style="margin-left: 10px">
                <p class="text-over">
                  微信昵称：{{ scope.row.hasUsers.nickname }}
                </p>
                <p class="text-over">
                  openid：{{ scope.row.hasUsers.open_id }}
                </p>
                <el-link
                  v-clipboard:success="copySuccess"
                  v-clipboard:copy="scope.row.hasUsers.mobile"
                  type="primary"
                  :underline="false"
                  >手机号：{{ scope.row.hasUsers.mobile }}
                </el-link>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="流水类型"
          prop="flow_type_mean"
        ></el-table-column>
        <el-table-column label="支出" prop="income">
          <template slot-scope="scope">
            <div>{{ scope.row.income }}</div>
          </template>
        </el-table-column>
        <el-table-column label="收入" prop="expense">
          <template slot-scope="scope">
            <div>{{ scope.row.expense }}</div>
          </template>
        </el-table-column>
        <el-table-column label="剩余佣金">
          <template slot-scope="scope">
            <div>￥{{ scope.row.after_amount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="下级信息" width="350">
          <template slot-scope="scope">
            <div class="flex" v-if="scope.row.hasFriends">
              <div class="flex">
                <div class="ml10">
                  <p class="text-over">
                    微信昵称：{{ scope.row.hasFriends.nickname }}
                  </p>
                  <p class="text-over">
                    openid：{{ scope.row.hasFriends.open_id }}
                  </p>
                  <p>
                    <el-link
                      v-clipboard:success="copySuccess"
                      v-clipboard:copy="scope.row.hasFriends.mobile"
                      type="primary"
                      :underline="false"
                      >手机号：{{ scope.row.hasFriends.mobile }}
                    </el-link>
                  </p>
                </div>
              </div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="下级充值金额" prop="score">
          <template slot-scope="scope">
            <div v-if="scope.row.friend_pay_amount > 0">
              ￥{{ scope.row.friend_pay_amount }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="审核状态">
          <template slot-scope="scope">
            <p>{{ scope.row.audit_status | auditStatus }}</p>
          </template>
        </el-table-column>
        <el-table-column label="商户号状态">
          <template slot-scope="scope">
            <p>{{ scope.row.pay_status | payStatus }}</p>
          </template>
        </el-table-column>
        <el-table-column label="打款失败原因" width="150">
          <template slot-scope="scope">
            <p>{{ scope.row.remark == "" ? "-" : scope.row.remark }}</p>
          </template>
        </el-table-column>
        <el-table-column label="时间日期" width="250" sortable prop="created_at" >
          <template slot-scope="scope">
            <div class="flex">
              <div class="flex">
                <div class="ml10">
                  <p class="text-over">
                    账单时间：{{ scope.row.created_at || "-" }}
                  </p>
                  <p class="text-over">
                    申请时间：{{ scope.row.submit_time || "-" }}
                  </p>
                  <p class="text-over">
                    审核时间：{{ scope.row.audit_time || "-" }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-popconfirm
              v-if="scope.row.audit_status == 1 || scope.row.audit_status == 3"
              title="确定要审核通过吗？"
              @confirm="pass(scope.row.id, 0)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="primary"
                style="margin-right: 10px"
                >审核通过</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              v-if="scope.row.audit_status == 1"
              title="确定要驳回吗？"
              @confirm="reject(scope.row.id)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="danger"
                style="margin-top: 10px"
                >驳回</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              v-if="scope.row.audit_status == 2 && scope.row.pay_status == 3"
              title="确定要重试打款吗？"
              @confirm="pass(scope.row.id, 1)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="warning"
                style="margin-top: 10px"
                >重试打款</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex center mt10">
        <div>
          <el-pagination
            @current-change="getList"
            :current-page="search.page"
            background
            :page-size="datas.limit"
            layout="total, prev, pager, next"
            :total="datas.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  withdrawalIndex,
  withdrawalPass,
  withdrawalReject
} from "@/request/api/operation/operation";

export default {
  data() {
    return {
      datas: [],
      search: this.getSearch(),
      //编辑信息
      editloading: false,
      editdialog: false,
      editdata: {
        uid: 0,
        pay_money: ""
      },
      loading: false
    };
  },
  created() {
    this.getList(1);
  },
  filters: {
    auditStatus(e) {
      let text = "";
      switch (e) {
        case 1:
          text = "待审核";
          break;
        case 2:
          text = "已通过";
          break;
        case 3:
          text = "已驳回";
          break;
        default:
          text = "-";
          break;
      }
      return text;
    },
    payStatus(e) {
      let text = "";
      switch (e) {
        case 1:
          text = "等待打款";
          break;
        case 2:
          text = "已打款";
          break;
        case 3:
          text = "打款失败";
          break;
        default:
          text = "-";
          break;
      }
      return text;
    }
  },
  methods: {
    getSearch() {
      return {
        pay_status: 0,
        audit_status: 0,
        flow_type: 0,
        user_keyword: "",
        page: 1,
        is_commission: -1,
        is_score: -1,
        submit_time: [],
        audit_time: [],
        create_time: [],
        friend_keyword: "",
        sort: ""
      };
    },
    getList(page) {
      this.search.page = page;
      this.loading = true;
      withdrawalIndex({
        page: page,
        user_keyword: this.search.user_keyword,
        friend_keyword: this.search.friend_keyword,
        pay_status: this.search.pay_status,
        audit_status: this.search.audit_status,
        flow_type: this.search.flow_type,
        submit_time: this.search.submit_time,
        audit_time: this.search.audit_time,
        create_time: this.search.create_time,
        sort: this.search.sort
      })
        .then(res => {
          this.datas = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    refresh() {
      this.search = this.getSearch();
      this.getList(1);
    },
    // 复制
    copySuccess() {
      this.$message.success("复制成功");
    },
    pass(id, is_try_again) {
      withdrawalPass({
        id,
        is_try_again
      }).then(() => {
        this.$message.success("成功");
        this.getList(this.search.page);
      });
    },
    reject(id) {
      withdrawalReject({
        id
      }).then(() => {
        this.$message.success("成功");
        this.getList(this.search.page);
      });
    },
    orderby(e) {
      if (e.order != null) {
        let order = e.order == "descending" ? "desc" : "asc";
        this.search.sort = e.prop + "_" + order;
      } else {
        this.search.sort = "";
      }
      this.getList(1);
    }
  }
};
</script>
<style scoped>
.allMoney {
  margin-left: 20px;
}
.allMoney .num {
  font-size: 15px;
  color: #ff5646;
}
</style>
